/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_IncidentInputs */

const en_case_section_incident = /** @type {(inputs: Case_Section_IncidentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incident`)
};

const pt_br2_case_section_incident = /** @type {(inputs: Case_Section_IncidentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incidente`)
};

/**
* | output |
* | --- |
* | "Incident" |
*
* @param {Case_Section_IncidentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_incident = /** @type {((inputs?: Case_Section_IncidentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_IncidentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_incident(inputs)
	return pt_br2_case_section_incident(inputs)
});